import { getMapPdfs } from "apis/mapPdfApi";
import { doCall } from "common/genericSaga";
import { call, put, takeEvery } from "redux-saga/effects";
import {
  MONALBUMPHOTO_ARCHIVE_REQUESTED,
  MONALBUMPHOTO_ARCHIVE_REQUEST_FAILED,
  receiveMonAlbumPhotoArchive
} from "./monAlbumPhotoArchiveActions";

export function* doRequestMonAlbumPhotoArchive(action, requestInfo) {
  const payload = yield call(getMapPdfs, requestInfo);
  yield put(receiveMonAlbumPhotoArchive(payload));
}

export function* watchMonAlbumPhotoArchive() {
  yield takeEvery(
    MONALBUMPHOTO_ARCHIVE_REQUESTED,
    doCall(doRequestMonAlbumPhotoArchive, MONALBUMPHOTO_ARCHIVE_REQUEST_FAILED)
  );
}
